<!--<div bsModal #childModal="bs-modal" class="modal fade"  data-backdrop="static"-->
<!--     tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">-->
<!--  <div class="modal-dialog modal-dialog-scrollable">-->
<!--    <div class="modal-content">-->
<!--      <div id="modal-header">-->
<!--        <div class="row" id="row-modal-header">-->
<!--          <i class="fa fa-video-camera fa-2x col-sm-1" aria-hidden="true"></i>-->
<!--          <h5 class="col-sm-11">{{!checkTitleToEdit ? 'Tạo nhóm thoại' : 'Thêm thành viên vào nhóm'}}</h5>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="modal-body bodyAddGroup">-->
<!--        <form [formGroup]="groupChatForm">-->
<!--          <div *ngIf="!checkTitleToEdit" class="d-flex justify-content-center align-items-center">-->
<!--            <input class="form-control form-control-custom pl-0 border-0 pl-2 inputNameGroup"-->
<!--                   formControlName="subject"-->
<!--                   name="subject" placeholder="Tên nhóm" type="text" required=""/>-->
<!--          </div>-->
<!--          <div  class="modal-body bodyAddGroup">-->
<!--            <div class="m-0 px-0 py-2 d-flex align-items-center justify-content-between"-->
<!--                 (click)="addUserCodeToGroup(member)" *ngFor="let member of listMember">-->
<!--              <div class="row m-0 d-flex align-items-center">-->
<!--                <img class="contact-image" userAvatar [usercode]="member.usercode">-->
<!--                <div class="contact-content ">-->
<!--                  <div class="font-weight-bold">{{member.fullname || member.usercode}}</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <span>-->
<!--                        <div style="white-space: nowrap; margin-right: 25px">-->
<!--                            <i *ngIf="!arrMemberGroup.includes(member)"-->
<!--                               class="fa fa-circle-thin"-->
<!--                               style="width: 12px; height: 12px; border-radius: 50%; color: #e5e5e5; background-color: #e5e5e5"></i>-->
<!--                            <i *ngIf="arrMemberGroup.includes(member)"-->
<!--                               class="fa-check-circle fa"-->
<!--                               style="width: 12px; height: 12px; border-radius: 50%; color: #4ab6ee"></i>-->
<!--                        </div>-->
<!--                    </span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="row show-list-select">-->
<!--            <p>Danh sách đã chọn</p>-->
<!--            <div class="row">-->
<!--              <i class="fa fa-search icon-search-show-list" aria-hidden="true"></i>-->
<!--              <div class="list-select d-flex">-->
<!--                <div *ngFor="let member of arrMemberGroup"-->
<!--                     style="position: relative; padding: 3px; display: inline">-->
<!--                  <img class="avatar" userAvatar [usercode]="member.usercode"-->
<!--                       (click)="removeMemberFormGroup(member)">-->
<!--                  <i class="fa fa-times-circle-o deleteMember" aria-hidden="true"-->
<!--                     (click)="removeMemberFormGroup(member)"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </form>-->
<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button *ngIf="!checkTitleToEdit" class="btn btn-sm btn-primary pull-right submit-add"-->
<!--                (click)="submitForm()" [disabled]="arrMemberGroup.length < 2 || !groupChatForm.valid">-->
<!--          Tạo nhóm-->
<!--        </button>-->
<!--        <button *ngIf="checkTitleToEdit" class="btn btn-sm btn-primary pull-right submit-add"-->
<!--                (click)="submitForm()" [disabled]="arrMemberGroup.length < 1">-->
<!--          Thêm thành viêm-->
<!--        </button>-->
<!--        <button class="btn btn-primary btn-sm pull-right submit-add mr-1" (click)="childModal.hide()">-->
<!--          Hủy-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!--<div *ngIf="showHide" class="homePage">-->
<!--  <div class="container addGroup">-->
<!--    <div class="row title-addGroup">-->
<!--      <i class="fa fa-video-camera icon-title-addGroup" aria-hidden="true"></i>-->
<!--      <h5 class="text-title-addGroup">{{!checkTitleToEdit ? 'Tạo nhóm thoại' : 'Thêm thành viên vào nhóm'}}</h5>-->
<!--    </div>-->
<!--    <div class="content-addGroup">-->
<!--      <form [formGroup]="groupChatForm">-->
<!--        <div *ngIf="!checkTitleToEdit" class="d-flex justify-content-center align-items-center">-->
<!--          <input class="form-control form-control-custom pl-0 border-0 pl-2 inputNameGroup"-->
<!--                 formControlName="subject"-->
<!--                 name="subject" placeholder="Tên nhóm" type="text" required=""/>-->
<!--        </div>-->
<!--        <div class="bodyAddGroup">-->
<!--          <div class="m-0 px-0 py-2 d-flex align-items-center justify-content-between"-->
<!--               (click)="addUserCodeToGroup(member)"-->
<!--               *ngFor="let member of listMember">-->
<!--            <div class="row m-0 d-flex align-items-center">-->
<!--              <img class="contact-image-addGroup mr-2" userAvatar [usercode]="member.usercode">-->
<!--              <div class="contact-content ">-->
<!--                <div class="title-member-contact-addGroup font-weight-bold">{{member.fullname || member.usercode}}</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <span>-->
<!--                        <div style="white-space: nowrap; margin-right: 25px">-->
<!--                            <i *ngIf="!arrMemberGroup.includes(member)"-->
<!--                               class="fa fa-circle-thin"-->
<!--                               style="width: 12px; height: 12px; border-radius: 50%; color: #e5e5e5; background-color: #e5e5e5"></i>-->
<!--                            <i *ngIf="arrMemberGroup.includes(member)"-->
<!--                               class="fa-check-circle fa"-->
<!--                               style="width: 12px; height: 12px; border-radius: 50%; color: #4ab6ee"></i>-->
<!--                        </div>-->
<!--                    </span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="ml-1 mr-1 mb-2">-->
<!--          <div class="contact-list__search">-->
<!--            <search-input [placeholder]="'Tìm kiếm ...'" (onChanged)="searchContacts($event)"></search-input>-->
<!--            &lt;!&ndash;    <div class="text-center m-1">&ndash;&gt;-->
<!--            &lt;!&ndash;        <button (click)="selectRoom('company')" type="button" class="btn btn-block btn-light">&ndash;&gt;-->
<!--            &lt;!&ndash;            <i class="fa fa-video-camera"></i> Cuộc họp công ty</button>&ndash;&gt;-->
<!--            &lt;!&ndash;    </div>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row show-list-select">-->
<!--          <p>Danh sách đã chọn</p>-->
<!--          <div class="row">-->
<!--&lt;!&ndash;            <i class="fa fa-search icon-search-show-list" aria-hidden="true"></i>&ndash;&gt;-->
<!--            <div class="list-select d-flex">-->
<!--              <div *ngFor="let member of arrMemberGroup"-->
<!--                   style="position: relative; padding: 3px; display: inline">-->
<!--                <img class="avatar" userAvatar [usercode]="member.usercode"-->
<!--                     (click)="removeMemberFormGroup(member)">-->
<!--                <i class="fa fa-times-circle-o deleteMember" aria-hidden="true"-->
<!--                   (click)="removeMemberFormGroup(member)"></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <button *ngIf="!checkTitleToEdit" class="btn btn-primary pull-right submit-add"-->
<!--                (click)="submitForm()" [disabled]="arrMemberGroup.length < 2 || !groupChatForm.valid">-->
<!--          Tạo nhóm-->
<!--        </button>-->
<!--        <button *ngIf="checkTitleToEdit" class="btn btn-primary pull-right submit-add"-->
<!--                (click)="submitForm()" [disabled]="arrMemberGroup.length < 1">-->
<!--          Thêm thành viêm-->
<!--        </button>-->
<!--        <button class="btn btn-primary pull-right submit-add mr-1" (click)="hideChildModal()">-->
<!--          Hủy-->
<!--        </button>-->
<!--      </form>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<!--<div bsModal #childModal="bs-modal" class="modal fade" data-backdrop="static"-->
<div bsModal #childModal="bs-modal" class="modal fade" [config]="{backdrop: 'static'}" data-backdrop="static"
     tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content border-0" >
      <div id="modal-header">
        <div class="row mt-3 mb-2 ml-0">
          <div class="img-create-message-group col-sm-1"></div>
          <h5
            class="col-sm-11 text-white">{{!checkTitleToEdit ? 'Tạo cuộc nhóm hội thoại' : 'Thêm thành viên vào nhóm hội thoại'}}</h5>
        </div>
      </div>
      <div *ngIf="!checkTitleToEdit" class="form-group ml-2 mt-2 mr-2">
        <label for="nameGroup"><b>Nhập tên nhóm</b></label>
        <input id="nameGroup" class="form-control form-control-custom pl-0 pl-2 inputAddNameGroup"
               [(ngModel)]="nameGroup"
               name="subject" placeholder="Nhập tên nhóm ..." type="text" required=""/>
      </div>
      <div class="form-group ml-2 mr-2 mb-3" [ngClass]="!checkTitleToEdit ? '': 'mt-3'">
        <label for="inputName"><b>Tìm kiếm người muốn thêm vào nhóm</b></label>
        <search-input id="inputName" [placeholder]="'Tìm kiếm ...'" (onChanged)="searchContacts($event)"></search-input>
        <!--            <div class="text-center m-1">-->
        <!--                <button (click)="selectRoom('company')" type="button" class="btn btn-block btn-light">-->
        <!--                    <i class="fa fa-video-camera"></i> Cuộc họp công ty</button>-->
        <!--            </div>-->
      </div>
      <div class="modal-body contact-add-group-list p-0">
        <form [formGroup]="groupChatForm">
          <div class="m-0 px-0 py-2 d-flex align-items-center justify-content-between"
               *ngFor="let member of listMember" (click)="addUserCodeToGroup(member)">
            <div class="row m-0 d-flex align-items-center">
              <img class="contact-image" userAvatar [usercode]="member.usercode">
              <div class="contact-content ml-3">
                <div class="font-weight-bold">{{member.fullname || member.usercode}}</div>
              </div>
            </div>
            <div class="pull-right mr-2 text-nowrap">
              <i [ngClass]="!arrMemberGroup.includes(member) ? 'fa fa-circle fa-2x' : 'fa-check-circle fa fa-2x'"
                 [ngStyle]="!arrMemberGroup.includes(member) ? {'color': '#e5e5e5'} : {'color': '#4ab6ee'}"></i>
            </div>
          </div>
        </form>
      </div>
      <div class="show-list ml-2 mr-3" *ngIf="arrMemberGroup.length > 0">
        <div class="text-secondary font-size-title font-weight-bold">Danh sách đã chọn ({{arrMemberGroup.length}}):</div>
        <div class="row">
          <div class="list-select d-flex">
            <div *ngFor="let member of arrMemberGroup" class="list-member-add-group">
              <img class="contact-image" userAvatar [usercode]="member.usercode" [title]="member.fullname"
                   (click)="removeMemberFormGroup(member)">
              <i class="fa fa-times-circle-o delete-member" aria-hidden="true" title="Delete member"
                 (click)="removeMemberFormGroup(member)"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="!checkTitleToEdit" class="btn btn-sm pull-right submit-add text-white rounded-pill"
                (click)="submitForm()" [disabled]="arrMemberGroup.length < 2 || nameGroup.trim() == ''">Tạo nhóm
        </button>
        <button *ngIf="checkTitleToEdit" class="btn btn-sm pull-right submit-add text-white rounded-pill"
                (click)="submitForm()" [disabled]="arrMemberGroup.length < 1">Chỉnh sửa thành viên nhóm
        </button>
        <button class="btn btn-sm btn-light pull-right mt-1 mr-1 border border-primary text-primary rounded-pill"
                (click)="hideChildModal()">Hủy
        </button>
      </div>
    </div>
  </div>
</div>
